<template>
  <div>
    <p class="text-2xl mb-6">VASTs Costs</p>
    <v-card class="mb-6 pa-2" outlined>
      <filters />
    </v-card>

    <v-row>
      <v-col cols="12" md="12">
        <results />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { onMounted } from "@vue/composition-api";

import Filters from "@/components/regie/vasts-costs/filters/Filters.vue";
import Results from "@/components/regie/vasts-costs/tables/Results";
import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "VastsCosts",
  components: {
    Filters,
    Results,
  },
  setup(props, { emit }) {
    const { route } = useProxy();

    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      saveRmraView(route);
    });

    // =>  DATA
    return {};
  },
};
</script>

<style></style>
